<template lang="pug">
v-container(:key="mKey" fluid class=" md:tw-pt-2 tw-pt-0 pb-0  tw-h-full tw-overflow-hidden tw-mx-0 tw-px-0 tw-bg-white ")
  template(v-if="loading")
    div(class=" tw-flex tw-flex-col tw-h-full  tw-overflow-hidden tw-rounded-tr tw-rounded-tl")
      div(class=" tw-flex-col ")
        v-skeleton-loader(type="table-heading" class=" tw-p-0 tw-m-0")
      div(class=" tw-flex-col tw-flex-1 tw-overflow-y-scroll tw-overflow-x-hidden")
        v-skeleton-loader(type="image, list-item-two-line, list-item-three-line" class=" tw-p-0 tw-m-0")
      div(class=" tw-flex-col ")
        v-skeleton-loader(type="actions")
  template(v-else)
    div(class=" tw-flex tw-flex-col tw-h-full  tw-overflow-hidden tw-rounded-tr tw-rounded-tl tw-rounded")
      div(class=" tw-flex-col ")
        v-row(class="pt-0 mt-0 tw-bg-indigo-lighten-5  tw-overflow-hidden")
          v-col(class="tw-pl-6")
            v-row(no-gutters)
              v-col
                span(class=" tw-text-left tw-font-semibold text-secondary tw-text-xl ") {{ lead.name }} {{ lead.last_name }}
            v-row(no-gutters class="tw-pt-2 " align="center")
              v-col(cols="auto" class=" tw-mr-3")
                span(v-if="lead.phone" class=" text-caption tw-text-gray-darken-2")
                  v-icon(small class="tw-mr-1") mdi-phone-classic
                  | {{ lead.phone }}
              v-col(cols="")
                span(v-if="lead.email" class=" text-caption tw-text-gray-darken-2")
                  v-icon(small class="tw-mr-1") mdi-email
                  | {{ lead.email }}

          v-col(cols="auto" class=" tw-text-right tw-pr-5 ")
            v-row(no-gutters)
              v-col
                span(class="tw-text-indigo-lighten-3 tw-font-bold tw-text-lg tw-capitalize ") {{ $t('Leads.Common.lead') }} \#{{ lead.id }}
            v-row(no-gutters class="tw-pt-1")
              v-col
                span(class="tw-text-gray-darken-2") {{ this.$moment(lead.created_at).fromNow() }}
        v-row(v-if="lead.property" no-gutters)
          v-col
            kubiqa-goods-list-item 
      div(class=" tw-flex-col tw-pb-4 tw-overflow-y-scroll tw-overflow-x-hidden tw-border tw-border-gray-lighten-3 tw-px-3")
        v-row(class="tw-pt-3")
          v-col(v-if="lead.message")
            | {{ lead.message }}
      div(
        class=" tw-flex-col-reverse tw-flex tw-flex-1 tw-overflow-y-scroll tw-overflow-x-hidden tw-border tw-border-gray-lighten-3 tw-border-t-0 tw-pt-4  "
      )
        v-row(v-if="lead.thread && lead.thread.email_messages.length > 0" no-gutters)
          v-col(class="tw-mb-8")
            kubiqa-misc-email-messages(:messages="lead.thread.email_messages")
      div(class="tw-flex-col ")
        template(v-if="allowReply == true && replyWindow == false")
          v-row(
            no-gutters
            align="center"
            justify="space-between"
            class=" tw-mt-6 tw-px-4 tw-pb-4 md:tw-pb-0  tw-bg-indigo-lighten-4 tw-bg-opacity-25 tw-w-full tw-rounded-bl tw-rounded-br"
          )
            v-col(cols="12" md="auto")
              v-btn(depressed block color="rgba(94,129,244,0.80)" @click="replyWindow = true")
                span(class="tw-font-bold") {{ $t('Leads.Common.reply') }}
            v-col(v-if="lead.status === 'new' && !$vuetify.breakpoint.mobile" cols="auto")
              v-row(no-gutters align="center" justify="end")
                v-col(cols="auto")
                  v-btn(
                    x-small
                    text
                    elevation="0"
                    :ripple="false"
                    @click="discard()"
                  )
                    span(class=" tw-text-xs tw-pt-4 tw-text-gray-darken-1") {{ $t('Leads.Common.discard') }}
                v-col(cols="auto")
                  v-btn(outlined color="indigo lighten-2" @click="addOpportunityDialogToggle()")
                    span(class="tw-font-bold") {{ $t('Opportunities.Common.createOpportunity') }}
            v-col(v-if="lead.status == 'converted' && !$vuetify.breakpoint.mobile" cols="auto")
              v-row(
                no-gutters
                align="center"
                justify="end"
                class=" tw-mt-6 tw-px-4   tw-bg-opacity-25 tw-w-full tw-rounded-bl tw-rounded-br"
              )
                v-col(cols="auto" class="tw-my-4")
                  v-chip(
                    color="white"
                    :to="{ name: 'opportunityTasks', params: { id: lead.opportunity.id } }"
                    class="tw-border tw-border-gray-lighten-1"
                  )
                    v-icon(x-small color="green lighten-2 ") mdi-circle
                    span(class="tw-ml-2") {{ $t('Leads.Common.converted') }}
            v-col(v-if="lead.status == 'discarded'" cols="auto")
              v-row(
                no-gutters
                align="center"
                justify="end"
                class=" tw-mt-6 tw-px-4  tw-bg-opacity-25 tw-w-full tw-rounded-bl tw-rounded-br"
              )
                v-col(cols="auto" class="tw-my-4")
                  v-chip(color="white" class="tw-border tw-border-gray-lighten-1")
                    v-icon(x-small color="orange lighten-1 ") mdi-circle
                    span(class="tw-ml-2") {{ $t('Leads.Common.discarded') }}
        template(v-if="allowReply == true && replyWindow == true")
          v-row
            v-col
              kubiqa-misc-email-message-editor(
                height="200px"
                ref="editor"
                @loading="(status) => (emailSending = status)"
                @close="(status) => (replyWindow = status)"
              )
          v-row(
            no-gutters
            align="center"
            justify="space-between"
            class=" tw-pb-4 md:tw-pb-0 tw-mt-6 tw-px-4 tw-bg-indigo-lighten-4 tw-bg-opacity-25 tw-w-full tw-rounded-bl tw-rounded-br"
          )
            v-col(cols="12")
              v-row(justify="space-between")
                v-col(cols="auto")
                  v-row(no-gutters align="center" justify="end" class="  ")
                    v-col(cols="auto")
                      v-btn(depressed color="rgba(94,129,244,0.80)" :loading="emailSending" @click="send()")
                        span(class="tw-font-bold") {{ $t('Common.send') }}
                    v-col(cols="auto")
                      v-btn(
                        x-small
                        text
                        elevation="0"
                        :ripple="false"
                        @click="replyWindow = false"
                      )
                        span(class=" tw-text-xs tw-pt-4 tw-text-gray-darken-1") {{ $t('Common.cancel') }}

    v-dialog(v-model="addOpportunityDialog" width="75%" max-width="75%")
      div(class="tw-bg-white add-listing-modal")
        kubiqa-opportunities-add(:key="mKey" @close="addOpportunityDialogToggle")
</template>
<script>
export default {
  data() {
    return {
      addOpportunityDialog: false,
      mKey: 1,
      loading: true,
      allowReply: true,
      replyWindow: false,
      emailSending: false,
    };
  },
  computed: {
    id() {
      return this.$route.params.id;
    },
    lead() {
      return this.$store.getters['leads/current_lead'];
    },
  },
  mounted: function () {
    this.loading = true;
    this.$store
      .dispatch('leads/view', this.id)
      .then(() => {
        this.loading = false;
      })
      .catch((error) => {
        commit('SET_ERROR', error, { root: true });
      });
  },
  methods: {
    addOpportunityDialogToggle() {
      this.mKey = ++this.mKey;
      return (this.addOpportunityDialog = !this.addOpportunityDialog);
    },
    discard() {
      this.loading = true;
      let payload = JSON.parse(JSON.stringify(this.lead));
      payload.status = 'discarded';
      delete payload.opportunity;
      delete payload.property;
      this.$store.dispatch('leads/update', payload);
    },
    send() {
      this.$refs.editor.send();
    },
  },
};
</script>
